import FeatFeatureSnippet from "./FeatFeatureSnippet";

export default FeatFeatureSnippet;
export { FeatFeatureSnippet };
